// extracted by mini-css-extract-plugin
export default {"textarea":"oL8XOoik"};